import { FTProcess } from '@/models/FTProcess';
import { weightToPieces, shapeArea, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            form: ['roll']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'No. Of Layers',
              type: 'text',
              value: 'layers',
              unit: 'layers',
              disabled: false
            },
            {
              name: 'Quantity (All layers)',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Shape',
          type: 'dropdown',
          optionsArray: [ 'Round', 'Oval', 'Rectangle', 'Rectangle+Oval', 'Other'],
          value: 'shape',
          disabled: false
        },
        {
          name: 'Width',
          type: 'dimension',
          value: 'width',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Length',
          type: 'dimension',
          value: 'length',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Structure',
          type: 'label',
          value: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.structure', ''),
          disabled: true
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'No of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  let totalSheetNumber = 0;
  const processInputRow = process.inputs[0];
  const outputFTProcessRow = process.outputs[0];
  outputFTProcessRow.goodsObject.copyFrom(processInputRow.goodsObject);
  outputFTProcessRow.quantity = processInputRow.quantity;
  conversionResult.outputs[0] = outputFTProcessRow;
  process.machineDetail.pcsPerStroke = 1;
  if (processInputRow.goodsObject.dimensions && outputFTProcessRow.dimensions && outputFTProcessRow.dimensions.length) {
      totalSheetNumber += weightToPieces(processInputRow.quantity / processInputRow.layers, processInputRow.goodsObject.density,  processInputRow.goodsObject.dimensions.width * outputFTProcessRow.dimensions.length);
  }
  outputFTProcessRow.goodsObject.density *= processInputRow.layers;
  outputFTProcessRow.goodsObject.unitWeight = (outputFTProcessRow.goodsObject.density * shapeArea({
      shape: outputFTProcessRow.dimensions.shape,
      params: outputFTProcessRow.dimensions,
      outUnit: 'm'
  })) / 1000;
  const value = totalSheetNumber / processInputRow.quantity;
  outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);

  conversionResult.details.numberOfPieces = outputFTProcessRow.goodsObject.perKgRatio.plA.value * processInputRow.quantity;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputFTProcessRow.quantity;
  conversionResult.details.kgPerHour = 60 * outputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed;
  conversionResult.details.plannedHours = (conversionResult.details.numberOfPieces * outputFTProcessRow.goodsObject.unitWeight) / conversionResult.details.kgPerHour;

  return conversionResult;
}